export const isPromise = (p) => {
	if (p == null) {
		return false;
	}

	return Object.prototype.toString.call(p) === '[object Promise]';
};
